/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FileWordIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'File Word',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M20 2v10h10L20 2z" />
    <path
      d="M19 14a1 1 0 0 1-1-1V2H7a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V14Zm4.295 15.992a.56.56 0 0 1-.568.408h-1.973a.546.546 0 0 1-.539-.325l-.436-1.83a694.87 694.87 0 0 1-1.355-5.912c-.449 1.891-1.137 4.492-1.639 6.391l-.32 1.214a.559.559 0 0 1-.57.463h-1.934a.606.606 0 0 1-.545-.34L10.27 18.048l.146-.274.121-.143.279-.031h2.066a.527.527 0 0 1 .578.474c.894 3.754 1.389 5.919 1.676 7.29.092-.38.2-.817.322-1.325.334-1.372.8-3.267 1.437-5.983a.55.55 0 0 1 .57-.455h2.117a.535.535 0 0 1 .527.425l.232.977a385.655 385.655 0 0 1 1.463 6.351c.309-1.521.8-3.821 1.57-7.292a.56.56 0 0 1 .572-.46h2.1l.23.178a.543.543 0 0 1 .109.45Z"
    />
  </svg>`;
};
